<template>
    <div class="bg-indigo-50 p-5 rounded">
        <div class="font-bold">Количество сканирований</div>
        <div class="mt-2">
            сканирований с одного устройства <select name="" v-model="comparisonType">
            <option value="equal">=</option>
            <option value="less">&lt;</option>
            <option value="more">></option>
        </select> <input type="number" v-model="count"
                   min="1" required>
        </div>
    </div>
</template>

<script>
import '@vuepic/vue-datepicker/dist/main.css'

export default {
    props: {
        modelValue: {
            required: true
        }
    },

    mounted() {
        if (this.modelValue.count) {
            this.count = this.modelValue.count
            this.comparisonType = this.modelValue.comparisonType
        } else {
            this.updateModelValue()
        }
    },

    watch: {
        count() {
            this.updateModelValue()
        },

        comparisonType() {
            this.updateModelValue()
        }
    },

    data() {
        return {
            count: 1,
            comparisonType: 'equal'
        };
    },

    methods: {
        updateModelValue() {
            this.$emit('update:modelValue', {count: this.count, comparisonType: this.comparisonType})
        }
    }
}
</script>
